import { Avatar, Box, Button, Stack, Tooltip, Typography } from "@mui/material"
import { EnderecoBox, EnderecoInfoBox, EnderecoPaperContainer } from "./styles"
import { IEndereco } from "../../../core/interfaces/IEndereco"
import { Edit, LocalOfferOutlined, LocationOn } from "@mui/icons-material";
import { IconSquareButton } from "../../../core/components/IconSquareButton";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import React from "react";
import { AvatarBox } from "../ClientePaper/styles";

interface EnderecoPaperProps {
    endereco: IEndereco | undefined;
    alterarEndereco?: () => void;
    desabilitar?: boolean | undefined;
    alterarPrecoFrete?: () => void;
}

const MAX_TEXT_LENGTH = 16;

const truncateText = (text?: string | null) => {
    if (!text) return '';
    return text.length > MAX_TEXT_LENGTH ? `${text.slice(0, MAX_TEXT_LENGTH)}...` : text;
}

export const EnderecoPaper = ({ alterarEndereco, endereco, desabilitar, alterarPrecoFrete }: EnderecoPaperProps) => {
    let enderecoString1 = endereco?.rua ?? "";

    if (endereco?.numero) {
        enderecoString1 += ` ${endereco?.numero}`;
    }

    let enderecoString2 = "";

    if (endereco?.bairro || endereco?.cidade) {
        const bairro = endereco?.bairro ?? "";
        const cidade = endereco?.cidade ?? "";
        enderecoString2 = bairro && cidade ? `${bairro} - ${cidade}` : `${bairro}${cidade}`;
    }

    if (endereco?.complemento) {
        enderecoString2 = enderecoString2
            ? `${endereco.complemento}, ${enderecoString2}`
            : endereco.complemento;
    }

    const enderecoCompleto = `${enderecoString1} ${enderecoString2}`.trim();

    return (
        <EnderecoPaperContainer endereco={endereco}>
            <Tooltip title={enderecoCompleto}>
                <EnderecoInfoBox>
                <Avatar sx={{ bgcolor: 'grey.200' }}>
                        <LocationOn sx={{ color: 'text.secondary' }} />
                    </Avatar>
                    <EnderecoBox endereco={endereco}>
                    {!endereco && (
                        <Typography 
                            sx={{ 
                                fontFamily: 'Poppins, sans-serif',
                                color: 'grey.500',
                                fontSize: 11
                            }}
                        >
                            ENDEREÇO
                        </Typography>
                    )}
                        {endereco ? (
                            <>
                                <Typography component={"p"} variant="body2" fontWeight={500} fontSize={12}>
                                    {truncateText(enderecoString1)}
                                </Typography>
                                <Typography component={"p"} variant="body2" fontWeight={300} fontSize={10}>
                                    {truncateText(enderecoString2)}
                                </Typography>
                            </>
                        ) : (
                            <Typography component={"p"} variant="body2" fontWeight={500} fontSize={13} color="text.primary">
                                Indefinido
                            </Typography>
                        )}
                    </EnderecoBox>
                </EnderecoInfoBox>
            </Tooltip>
            {endereco && (
                <Stack spacing={0.5} sx={{ mt: 0.5 }}>
                    <Tooltip title="Alterar endereço">
                        <IconSquareButton
                            onClick={alterarEndereco}
                            disabled={desabilitar}
                            color="primary"
                            icon={<Edit />}
                        />
                    </Tooltip>

                    {alterarPrecoFrete && (
                        <Tooltip title="Alterar preço do frete">
                            <IconSquareButton
                                onClick={alterarPrecoFrete}
                                disabled={desabilitar}
                                color="secondary"
                                icon={<LocalOfferOutlined />}
                            />
                        </Tooltip>
                    )}
                </Stack>
            )}
        </EnderecoPaperContainer>
    )
}